<template>
  <v-container fluid>
    <div v-if="company">
      <v-snackbar color="green" timeout="2000" v-model="companySaved">
        Company Saved
      </v-snackbar>
      <v-row>
        <v-col cols="12" class="text-center">
          <span class="text-h3">{{ modelCompany.name }}</span>
        </v-col>
      </v-row>
      <v-divider class="pb-10 mt-2"></v-divider>
      <v-form @submit.prevent="submit" ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.name"
                  label="Company Name:"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.companyEmail"
                  label="Company Email:"
                  type="string"
                  :rules="emailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Months"
                  label="Monthly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Weeks"
                  label="Weekly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.pastelCode"
                  label="Company Code:"
                  type="string"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="this.createdAt"
                  label="Created:"
                  type="string"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.WksMths"
                  label="Wks/Mths Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="modelCompany.loanApplicationEmails.Fortnights"
                  label="Fortnightly Email(s):"
                  type="string"
                  :rules="multipleEmailRule"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-row class="ma-3">
            <v-combobox
              v-model="addLoanTypes"
              label="Loan Types:"
              item-text="code"
              item-value="id"
              type="number"
              @change="validateLoanTypes()"
              multiple
              persistent-hint
              chips
              deletable-chips
              clearable
              :error-messages="errorMessage"
            ></v-combobox
          ></v-row>
        </v-row>
      </v-form>
      <v-row class="ma-1">
        <v-spacer></v-spacer>
        <v-btn
          width="4vh"
          color="green"
          :disabled="!valid"
          dark
          @click="submit()"
        >
          Save
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { CompanyLoanType, Company } from "@/models";
import { DataStore } from "@aws-amplify/datastore";
import _ from "lodash";
import { showErrorSnackbar } from '@/mixins/errorHandler';

export default {
  name: "ViewSingleCompany",

  props: {
    company: {},
    loanTypes: null,
  },

  data: () => ({
    companySaved: false,
    addLoanTypes: [],
    queriedLoanTypeCodes: null,
    queriedLoanTypes: null,
    nonExistantLoanTypes: [],
    valid: false,
    errorMessage: "",
    queriedCompany: {},
    modelCompany: {
      loanApplicationEmails: {
        Months: "",
        Weeks: "",
        WksMths: "",
        Fortnights: "",
      },
    },
    createdAt: "",

    requiredRule: [(v) => !!v || "Required"],
    emailRule: [(v) => !v || /.+@.+\..+/.test(v) || "E-mail must be valid"],
    multipleEmailRule: [
      (v) =>
        !v ||
        /^([a-z][a-z0-9_.]+@([a-z0-9-]+\.)+[a-z]{2,6}(, )*(,)*)+$/.test(v) ||
        "E-mail must be valid",
    ],
  }),

  created() {
    this.subscription = DataStore.observe(CompanyLoanType).subscribe(() => {
      this.getCompanyDetails();
    });
    this.getCompanyDetails();
  },
  components: {},

  methods: {
    async getCompanyDetails() {
      try {
        const queryCompany = await DataStore.query(Company, (c) =>
          c.id("eq", this.company.id)
        );
        this.queriedCompany = queryCompany[0];
        this.modelCompany = _.cloneDeep(queryCompany[0]);

        this.queriedLoanTypes = (await DataStore.query(CompanyLoanType)).filter(
          (ltc) => ltc.company.id === this.modelCompany.id
        );
        this.queriedLoanTypeCodes = this.queriedLoanTypes.map((ltc) =>
          ltc.loanType.code.toString()
        );

        this.addLoanTypes = _.cloneDeep(this.queriedLoanTypeCodes);
        this.createdAt = this.modelCompany.createdAt.slice(0, 10);
      } catch (error) {
        console.log(error);
        showErrorSnackbar();
      }
    },
    validateLoanTypes() {
      try {
        this.nonExistantLoanTypes = [];
        this.errorMessage = "";
        if (this.addLoanTypes) {
          for (let a in this.addLoanTypes) {
            const modelFilteredLoanType = _.find(this.loanTypes, {
              code: Number(this.addLoanTypes[a]),
            });

            if (!modelFilteredLoanType) {
              this.nonExistantLoanTypes = _.concat(
                this.nonExistantLoanTypes,
                this.addLoanTypes[a]
              );
            }
          }
          if (this.nonExistantLoanTypes.length > 0) {
            this.errorMessage = `Incorrect Loan Type(s): ${this.nonExistantLoanTypes}`;
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async submit() {
      try {
        let arrLoanTypes = [];

        if (this.addLoanTypes) {
          for (let a in this.addLoanTypes) {
            const modelFilteredLoanType = _.find(this.loanTypes, {
              code: Number(this.addLoanTypes[a]),
            });

            if (modelFilteredLoanType) {
              arrLoanTypes = _.concat(arrLoanTypes, modelFilteredLoanType);
            }
          }
        }
        if (this.nonExistantLoanTypes.length === 0) {
          // console.log("trueeeeeeeeeeee");
          await DataStore.save(
            Company.copyOf(this.queriedCompany, (updateCompany) => {
              (updateCompany.id = this.modelCompany.id),
                (updateCompany.name = this.modelCompany.name),
                (updateCompany.pastelCode = this.modelCompany.pastelCode
                  .trim()
                  .toUpperCase()),
                (updateCompany.loanApplicationEmails =
                  this.modelCompany.loanApplicationEmails),
                (updateCompany.companyEmail = this.modelCompany.companyEmail);
            })
          );
        }

        let loanTypeDifferences = _.xor(
          this.queriedLoanTypeCodes,
          this.addLoanTypes
        );

        for (let ltd in loanTypeDifferences) {
          if (this.queriedLoanTypeCodes.includes(loanTypeDifferences[ltd])) {
            let companyLoanTypeToDelete = this.queriedLoanTypes.filter(
              (ltm) => ltm.loanType.code === Number(loanTypeDifferences[ltd])
            );
            await DataStore.delete(companyLoanTypeToDelete[0]);

            _.pull(this.queriedLoanTypeCodes, loanTypeDifferences[ltd]);
            _.pull(this.queriedLoanTypes, companyLoanTypeToDelete[0]);
          } else {
            let companyLoanTypeToSave = _.find(this.loanTypes, {
              code: Number(loanTypeDifferences[ltd]),
            });
            let newLoanType = await DataStore.save(
              new CompanyLoanType({
                company: this.queriedCompany,
                loanType: companyLoanTypeToSave,
              })
            );
            this.queriedLoanTypeCodes.push(loanTypeDifferences[ltd]);
            this.queriedLoanTypes.push(newLoanType);
          }
        }
        this.companySaved = true;
      } catch (error) {
        console.log("error", error);
      }
    },
  },
  computed: {},
};
</script>